import React from "react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/32486321452?text=Bonjour,%20je%20souhaite%20avoir%20plus%20d'informations%20sur%20vos%20services."
      style={{
        backgroundColor: "#25D366",
        color: "white",
        padding: "10px 20px",
        textDecoration: "none",
        borderRadius: "5px",
        fontSize: "16px",
      }}
      target="_blank"
      rel="noreferrer"
    >
      Sur WhatsApp
    </a>
  );
};

export default WhatsAppButton;
